import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { PaginatedResult, PaginationCriteria } from 'jul-web-shared-lib';
import { ApiEndpoints } from '../core/http/api-endpoints';
import { JulContextLibService } from 'jul-web-shared-lib/src/lib/components/context';
import { Task } from '../core/models/notifications/task.model';

@Injectable({
  providedIn: 'root'
})
export class TaskService {

  constructor(private http: HttpClient, private julContextService: JulContextLibService) { }

  getPaginated(criteria: PaginationCriteria<Task>): Observable<PaginatedResult<Task[]>> {
    this.julContextService.setContextNational();
    let paginatedResult: PaginatedResult<Task[]> = new PaginatedResult<Task[]>();

    return this.http.post(ApiEndpoints.core.task.search(), criteria, {observe: 'response'}).pipe(
      map((response: any)  => {
        paginatedResult = response.body.data;
        return paginatedResult;
      }
    ));
  }

  getUnreads(idUser: string): Observable<any> {
    this.julContextService.setContextNational();
    // return this.getPaginated(criteria);
    const filter  = {
      'filters': {
        'read': false,
        'idUser': idUser
      }
     };
    return this.count(filter);
  }

  getCount(): Observable<any> {
    this.julContextService.setContextNational();
    return this.http.post<Notification>(ApiEndpoints.core.task.count(), {"filters": {"archived": false, "read": false }}).pipe(
      map((response: any)  => <Notification>response.data)
    );
  }

  read(id:string){
    this.julContextService.setContextNational();
    return this.http.put(ApiEndpoints.core.task.read(id), null);
  }

  unread(id:string){
    this.julContextService.setContextNational();
    let task = {id:id} as any;
    return this.http.post(ApiEndpoints.core.task.unread(), task);
  }

  archive(id:string){
    this.julContextService.setContextNational();
    let archive = {
      "bulkOperation": "ARCHIVE",
      "justification": null,
      "ids": [
        id
      ]
    };
    return this.http.put(ApiEndpoints.core.task.archive(), archive);
  }

  multipleArchive(idArrays: any){
    this.julContextService.setContextNational();
    let archive = {
      "bulkOperation": "ARCHIVE",
      "justification": null,
      "ids": idArrays
    };
    return this.http.put(ApiEndpoints.core.task.archive(), archive);
  }

  restore(id: string) {
    this.julContextService.setContextNational();
    const task = {id: id} as any;
    return this.http.post(ApiEndpoints.core.task.restore(), task);
  }

  getAll(): Observable<Task[]> {
    this.julContextService.setContextNational();
    return this.http.get<Task[]>(ApiEndpoints.core.task.getAll()).pipe(
      map((response: any)  => <Task[]>response.data)
    );
  }

  get(id: string): Observable<Task> {
    this.julContextService.setContextNational();
    return this.http.get<Task>(ApiEndpoints.core.task.get(id)).pipe(
      map((response: any)  => <Task>response.data)
    );
  }

  getRevisions(criteria: PaginationCriteria<any>): Observable<PaginatedResult<any[]>> {
    this.julContextService.setContextNational();
    let paginatedResult: PaginatedResult<any[]> = new PaginatedResult<any[]>();

    return this.http.post(ApiEndpoints.core.task.revisions(), criteria, {observe: 'response'}).pipe(
      map((response: any)  => {
        paginatedResult = response.body.data;
        return paginatedResult;
      }
    ));
  }


  count(filter: any): Observable<any> {
    this.julContextService.setContextNational();
    return this.http.post(ApiEndpoints.core.task.count(), filter).pipe(map((response: any)  => {
      return response.data;
    }));
  }

  create(task: Task) {
    this.julContextService.setContextNational();
    return this.http.post(ApiEndpoints.core.task.post(), task);
  }

  update(task: Task) {
    this.julContextService.setContextNational();
    return this.http.put(ApiEndpoints.core.task.put(), task);
  }


  delete(id: string, versionNumber: string) {
    this.julContextService.setContextNational();
    return this.http.delete(ApiEndpoints.core.task.delete(id, versionNumber));
  }



}

